import React, { ComponentProps, FC } from 'react'
import cx from 'classnames'

import { ContextMenu } from '../ContextMenu'
import {
  Description,
  ItemIcon,
  ItemWrapper,
  Label,
  SvgIconWrapper,
  TextSection
} from './BaseItem.styles'
import SvgIcon from '../../Icon/SvgIcon'
import { DropdownMenuItemBase } from './types'
import { useThemeColors } from '../../../../defaultTheme'
import { Dictionary } from '@feedyou/schema'

type BaseItemProps = {
  className?: string
  item: DropdownMenuItemBase
  renderAs?: ComponentProps<typeof ItemWrapper>['as']
  leaveSpaceForSubmenu: boolean
  onContextMenuClick?: () => void
}

export const BaseItem: FC<BaseItemProps> = ({
  item,
  renderAs,
  className,
  leaveSpaceForSubmenu,
  onContextMenuClick
}) => {
  const {
    icon,
    label,
    isActive,
    textColor,
    description,
    submenuItems,
    svgIcon,
    type,
    className: itemClassName,
    onClick,
    dataTest
  } = item

  const themeColors = useThemeColors() as Dictionary<string, string>
  const textColorHex = themeColors[textColor!] || textColor

  return (
    <ItemWrapper
      as={renderAs}
      $isActive={isActive}
      className={cx(className, itemClassName)}
      onClick={onClick}
      $leaveSpaceForSubmenu={leaveSpaceForSubmenu}
      data-test={cx('menu-item', dataTest && `menu-item--${dataTest}`, `type--${type}`)}
    >
      {svgIcon ? (
        <SvgIconWrapper>
          <SvgIcon name={svgIcon} />
        </SvgIconWrapper>
      ) : (
        icon && (
          <SvgIconWrapper>
            <ItemIcon icon={icon} />
          </SvgIconWrapper>
        )
      )}
      <TextSection className={type}>
        <Label color={textColorHex}>{label}</Label>
        {description && <Description>{description}</Description>}
      </TextSection>
      {submenuItems && submenuItems.length && (
        <ContextMenu items={submenuItems} onMenuClick={onContextMenuClick} />
      )}
    </ItemWrapper>
  )
}
